<template>
  <div id="location-options" class="modal" :class="{show: modalActive}" tabindex="-1" ref="locationModal">
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-transform-uppercase">Available Cities in {{state}}</h5>
          <button type="button" class="close" data-dismiss="location-options" aria-label="Close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="location-info w-100" v-if="cities.length > 0">
            <ul class="list-group list-group-flush">
              <li v-for="(city,index) in cities" :key="index" class="list-group-item">{{city.city}}, {{state}}</li>
            </ul>
          </div>
          <div class="no-results" v-else>
            <h3>No Cities Available in {{state}}</h3>
          </div>
          <p class="availability-disclaimer">Don’t see your market listed? Click "Get Started" below to learn about availability in your area.</p>
        </div>
        <div class="modal-footer">
          <a class="btn btn-primary btn-get-started mx-auto font-weight-bold text-uppercase" href="#get-started">Get Started</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CityModal',
  props: {
    state: String,
    cities: Array,
    modalActive: Boolean
  },
  data() {
    return {
      modalOpen: false
    }
  },
  mounted(){
    this.modalOpen = true;
  },
  computed: {
    modal(){
      return this.$refs.locationModal;
    }
  },
  methods: {
    closeModal(){
      this.modalOpen = false;
      this.$emit('closeModal');
    }
  }
}
</script>
<style>
  #location-options.show {
    display:block;
  }
  .location-info {
    font-weight:bold;font-size:16px;
  }
  #location-options {
    position:absolute;
    left:auto;
    right:1rem;
    max-width:500px;
  }
  @media(max-width:767px){
    #location-options {
      left: 0;
      right: 0;
      margin: auto 5%;
      max-width: 90%;
    }
  }
  #location-options .location-info {

  }
  .location-info ul {
    padding-inline-start:0px;
  }
  .text-transform-uppercase {
    text-transform:uppercase;
    font-weight:bold;
  }
  .btn-get-started {
    background: #ffe300;
    color:black;
    border-color: black;
  }
  .btn-get-started:hover, .btn-get-started:focus {
    background: black;
    color:white;
    border-color: white;
    box-shadow: 0 0 0 0.2rem rgb(0 0 0 / 50%);
  }
  .availability-disclaimer {
    text-align:center;
    font-size:12px;
    font-style:italic;
    margin-top:10px;
    margin-left:2rem;
    margin-right:2rem;
  }
</style>